import { IUserCancellation, IUserPause } from "@smartrr/shared/entities/CancellationRelationship";

import { customerAsyncDispatch } from "@customer-app/state/customerAsyncDispatch";
import { CustomerThunkAction } from "@customer-app/state/typedCustomerRedux";

import { typedCustomerFrontendApi } from "../../../shared/typedCustomerFrontendApi";

export const saveUserPauseReasonAPI = (userPause: IUserPause) => {
  return typedCustomerFrontendApi.postReq("/user-pause", {
    reqBody: {
      submittedUserPause: userPause,
    },
  });
};

export const saveUserCancellationReasonAPI = (userCancellation: IUserCancellation) => {
  return typedCustomerFrontendApi.postReq("/user-cancellation", {
    reqBody: userCancellation,
  });
};

export function loadOrgAccountPlanAPI() {
  return typedCustomerFrontendApi.getReq("/account-plan/active-plan");
}

export const getCancellationReasons = () => {
  return typedCustomerFrontendApi.getReq("/cancellation-reasons");
};

export const getPauseReasons = () => {
  return typedCustomerFrontendApi.getReq("/pause-reasons");
};

export const loadOrgAccountPlan =
  (): CustomerThunkAction<
    "LOADING_ORGANIZATION_PLAN" | "ERROR_LOADING_ORGANIZATION_PLAN" | "LOADED_ORGANIZATION_PLAN"
  > =>
  dispatch =>
    customerAsyncDispatch(
      loadOrgAccountPlanAPI(),
      () =>
        dispatch({
          type: "LOADING_ORGANIZATION_PLAN",
          payload: undefined,
        }),
      failure =>
        dispatch({
          type: "ERROR_LOADING_ORGANIZATION_PLAN",
          payload: {
            errorMessage: failure.message,
          },
        }),
      accountPlan =>
        dispatch({
          type: "LOADED_ORGANIZATION_PLAN",
          payload: {
            accountPlan,
          },
        })
    );

export const loadCancellationReasons =
  (): CustomerThunkAction<
    "LOADING_CANCELLATION_REASONS" | "ERROR_LOADING_CANCELLATION_REASONS" | "LOADED_CANCELLATION_REASONS"
  > =>
  dispatch =>
    customerAsyncDispatch(
      getCancellationReasons(),
      () =>
        dispatch({
          type: "LOADING_CANCELLATION_REASONS",
          payload: undefined,
        }),
      failure =>
        dispatch({
          type: "ERROR_LOADING_CANCELLATION_REASONS",
          payload: {
            errorMessage: failure.message,
          },
        }),
      cancellationReasons =>
        dispatch({
          type: "LOADED_CANCELLATION_REASONS",
          payload: {
            cancellationReasons,
          },
        })
    );

export const saveUserCancellation =
  (
    userCancellation: IUserCancellation
  ): CustomerThunkAction<
    "SAVING_USER_CANCELLATION" | "ERROR_SAVING_USER_CANCELLATION" | "SAVED_USER_CANCELLATION"
  > =>
  dispatch =>
    customerAsyncDispatch(
      saveUserCancellationReasonAPI(userCancellation),
      () =>
        dispatch({
          type: "SAVING_USER_CANCELLATION",
          payload: undefined,
        }),
      failure =>
        dispatch({
          type: "ERROR_SAVING_USER_CANCELLATION",
          payload: {
            errorMessage: failure.message,
          },
        }),
      () =>
        dispatch({
          type: "SAVED_USER_CANCELLATION",
          payload: {
            userCancellation,
          },
        })
    );

export const loadPauseReasons =
  (): CustomerThunkAction<"LOADING_PAUSE_REASONS" | "ERROR_LOADING_PAUSE_REASONS" | "LOADED_PAUSE_REASONS"> =>
  dispatch =>
    customerAsyncDispatch(
      getPauseReasons(),
      () =>
        dispatch({
          type: "LOADING_PAUSE_REASONS",
          payload: undefined,
        }),
      failure =>
        dispatch({
          type: "ERROR_LOADING_PAUSE_REASONS",
          payload: {
            errorMessage: failure.message,
          },
        }),
      pauseReasons =>
        dispatch({
          type: "LOADED_PAUSE_REASONS",
          payload: {
            pauseReasons,
          },
        })
    );

export const saveUserPauseReason =
  (
    userPause: IUserPause
  ): CustomerThunkAction<
    "SAVING_USER_PAUSE_REASON" | "ERROR_SAVING_USER_PAUSE_REASON" | "SAVED_USER_PAUSE_REASON"
  > =>
  dispatch =>
    customerAsyncDispatch(
      saveUserPauseReasonAPI(userPause),
      () =>
        dispatch({
          type: "SAVING_USER_PAUSE_REASON",
          payload: undefined,
        }),
      failure =>
        dispatch({
          type: "ERROR_SAVING_USER_PAUSE_REASON",
          payload: {
            errorMessage: failure.message,
          },
        }),
      () =>
        dispatch({
          type: "SAVED_USER_PAUSE_REASON",
          payload: {
            userPause,
          },
        })
    );
